import { render, staticRenderFns } from "./LaSettings.vue?vue&type=template&id=3dbc30c7&scoped=true"
import script from "./LaSettings.vue?vue&type=script&lang=js"
export * from "./LaSettings.vue?vue&type=script&lang=js"
import style0 from "./LaSettings.vue?vue&type=style&index=0&id=3dbc30c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc30c7",
  null
  
)

export default component.exports